import React from 'react';

import Wrapper from '@components/Onboarding/OnboardingStep/Wrapper';

const NotFinished: React.FC = () => {
  return <Wrapper />;
};

export default NotFinished;
